var ResourceSearchConstants;
(function (ResourceSearchConstants) {
    ResourceSearchConstants["SUGGESTION_SELECTED_EVENT"] = "suggestion-selected-event";
    ResourceSearchConstants["TABLE_VIEW"] = "table";
    ResourceSearchConstants["VISUAL_VIEW"] = "visual";
    ResourceSearchConstants["RDF_SEARCH_ICON_CLICKED"] = "rdfSearchIconClicked";
})(ResourceSearchConstants || (ResourceSearchConstants = {}));

export { ResourceSearchConstants as R };
